"use client";

import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Menu } from "lucide-react";
import Sidebar from "./Block/Sidebar";

export function MobileSidebar() {
  return (
    <Sheet>
      <SheetTrigger asChild>
        <button
          type="button"
          aria-label="فتح القائمة"
          className="flex h-10 w-10 items-center justify-center rounded-xl border border-slate-200 bg-white text-[#1F0570] shadow-sm transition hover:bg-violet-50 lg:hidden"
        >
          <Menu className="h-5 w-5" />
        </button>
      </SheetTrigger>
      <SheetContent side="right" className="w-[280px] border-0 p-0">
        <Sidebar mobile />
      </SheetContent>
    </Sheet>
  );
}
